import React from 'react';
import PropTypes from 'prop-types';
import { LocationType } from '../../../constants';
import { parsePhoneNumber } from '../../../utils/phoneNumbers';
import CCProviderPhoneLink from './CCProviderPhoneLink';

export const renderPhoneNumber = (title, subTitle = null, phone, location) => {
  if (!phone) {
    return null;
  }

  const { extension, contact, processed, international, countryCode } =
    parsePhoneNumber(phone);
  // The Telephone component will throw an error if passed an invalid phone number.
  // Since we can't use try/catch or componentDidCatch here, we'll just do this:
  if (contact.length !== 10) {
    return null;
  }

  const phoneNumberId = `${location.id}-${title.replaceAll(/\s+/g, '')}`;

  const renderTTY = title.includes('Main phone') && (
    <>
      {', '}
      (<va-telephone tty contact="711" />)
    </>
  );

  return (
    <p data-testid={title}>
      {title && <strong id={phoneNumberId}>{title}: </strong>}
      {subTitle}
      {processed ? (
        <>
          <va-telephone
            className={
              subTitle ? 'vads-u-margin-left--0p5' : 'vads-u-margin-left--0p25'
            }
            contact={contact}
            extension={extension}
            country-code={countryCode}
            international={international}
          />
          {renderTTY}
        </>
      ) : (
        // eslint-disable-next-line @department-of-veterans-affairs/prefer-telephone-component
        <a href={`tel:${contact}`} aria-describedby={phoneNumberId}>
          {contact}
        </a>
      )}
    </p>
  );
};

// NOTE: Do not use this component to display Covid19 appointment phone numbers.
// Use Covid19PhoneLink instead.

const LocationPhoneLink = ({
  location,
  query,
  showHealthConnectNumber = false,
}) => {
  const isProvider = location.type === LocationType.CC_PROVIDER;
  const { phone } = location.attributes;

  if (isProvider) {
    return (
      <CCProviderPhoneLink
        location={location}
        query={query}
        renderPhoneNumber={renderPhoneNumber}
      />
    );
  }

  return (
    <div className="facility-phone-group">
      {renderPhoneNumber('Main phone', null, phone.main, location)}
      {showHealthConnectNumber &&
        renderPhoneNumber(
          'VA health connect',
          null,
          phone.healthConnect,
          location,
        )}
      {renderPhoneNumber(
        'Mental health',
        null,
        phone.mentalHealthClinic,
        location,
      )}
    </div>
  );
};

LocationPhoneLink.propTypes = {
  from: PropTypes.string,
  location: PropTypes.object,
  query: PropTypes.object,
  showHealthConnectNumber: PropTypes.bool,
};

export default LocationPhoneLink;
